/* eslint-disable no-undef */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import { progressGuard } from './guards';

Vue.use(Router);

const router = new Router({
  mode: process.env.VUE_APP_HTML_HISTORY_MODE ? 'history' : '',
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/company-form',
      name: 'company-form',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // webpackChunkName says what will the import look like in the network tab.
      component: () => import(/* webpackChunkName: "company-form" */ '../views/CompanyForm.vue'),
    },
    {
      path: '/private-person-form',
      name: 'private-person-form',
      component: () => import(/* webpackChunkName: "private-person-form" */ '../views/PrivatePersonForm.vue'),
    },
    {
      path: '/signed-document-upload-form',
      name: 'signed-document-upload-form',
      component: () => import(/* webpackChunkName: "signed-document-upload-form" */ '../views/SignedDocumentUploadForm.vue'),
    },
    {
      path: '/agreements',
      name: 'agreements',
      component: () => import(/* webpackChunkName: "agreements" */ '../views/Agreements.vue'),
      beforeEnter: progressGuard,
    },
    {
      path: '/completed',
      name: 'completed',
      component: () => import(/* webpackChunkName: "completed" */ '../views/Completed.vue'),
      beforeEnter: progressGuard,
    },
    // {
    //   path: '/staff',
    //   name: 'staff',
    //   component: () => import(/* webpackChunkName: "staff" */ '../views/StaffForm.vue'),
    // },
    {
      path: '/choose-files',
      name: 'choose-files',
      component: () => import(/* webpackChunkName: "choose-files" */ '../views/FilePicker.vue'),
      beforeEnter: progressGuard,
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: () => import(/* webpackChunkName: "contact-us" */ '../views/ContactUs.vue'),
      beforeEnter: progressGuard,
    },
    {
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue'),
      beforeEnter: progressGuard,
    },
    {
      path: '/warrant-upload-form',
      name: 'warrant-upload-form',
      component: () => import(/* webpackChunkName: "warrant-upload-form" */ '../views/WarrantUploadForm.vue'),
      beforeEnter: progressGuard,
    },
    {
      path: '/sign-document/:id/:hash/:type',
      name: 'sign-document',
      component: () => import(/* webpackChunkName: "sign-document" */ '../views/SignSentDocument.vue'),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

ga('set', 'page', router.currentRoute.path);
ga('send', 'pageview');

router.afterEach((to) => {
  ga('set', 'page', to.path);
  ga('send', 'pageview');
});

export default router;
